<template>
  <dialogue
    v-if="dialogue.quoteTitle"
    :quoteTitle="dialogue.quoteTitle"
    :quoteText="dialogue.quoteText"
    :characterDescription="dialogue.characterDescription"
    :imageURL="dialogue.imageURL"
     :alignLeft="dialogue.alignLeft"
    :number="wayPoint.number"
  />
  <card
    v-else-if="card.title"
    :title="card.title"
    :subtitle="card.subtitle"
    :text="card.text"
    :imagesURLs="card.imagesURLs"
    :number="wayPoint.number"
  />
</template>

<script>
import Dialogue from "@/components/Dialogue";
import Card from "@/components/Card";

export default {
  name: "Waypoint",
  components: { Dialogue, Card },
  props: {
    wayPoint: Object,
  },
  data() {
    return {
      dialogue: {},
      card: {},
    };
  },
  methods: {
    renderContent: function() {

        this.dialogue = {}
        this.card = {}
        const content = this.wayPoint.content;

      // Handelt es sich um Dialogue oder Card Content?
      if (content.fields.quoteTitle) {
        this.dialogue.quoteTitle = content.fields.quoteTitle;
        this.dialogue.quoteText = content.fields.quoteText;
        this.dialogue.characterDescription = content.fields.characterDescription;
        this.dialogue.imageURL = content.fields.image.fields.file.url;
        this.dialogue.alignLeft = content.fields.alignLeft;
      } else {
        console.log("Render card");
        this.card.title = content.fields.title;
        this.card.subtitle = content.fields.subtitle;
        this.card.text = content.fields.text;
        this.card.imagesURLs = content.fields.images.map((image) => image.fields.file.url);
      }
    },
  },
  created(){
    this.renderContent();
  },
  beforeUpdate(){
    // console.log("Waypoint: this.wayPoint", this.wayPoint);
    this.renderContent();
  },
//   updated(){
//       this.renderContent();
//   }
  
};
</script>

<style scoped></style>
